import styled from 'styled-components';
import Button from 'antd/lib/button';

const StyledButton = styled(Button)``;

export { StyledButton };
